<div class="blocked-container width-660" tracking formname="Smart invest line simulation"
    stepname="Block  user  unknown  partner" submittrigger="button.ab-unknown-partner-block" stepclusterOptional="stop">
    <div class="blocked-intro-text" [innerHTML]="'Context.AdviceNonHappy.IntroText' | translate | punctuationWrap"></div>
    <h2 class="blocked-title" [innerHTML]="'Context.AdviceNonHappy.Title' | translate | punctuationWrap"></h2>
    <div class="blocked-image">
        <div id="jsonImageIcon" class="lottie blocked-large-image"></div>
    </div>
    <div class="blocked-content" [innerHTML]="'Context.AdviceNonHappy.Description' | translate | punctuationWrap"></div>
</div>
<app-cta-container [primaryBtnLabel]="'Context.AdviceNonHappy.CTA' | translate"
    [isPrimaryBtnBlue]="true"
    [isSecondaryBtnHidden]="true" (actionSelected)="nextAction($event)"
    adobeSubmitTriggerClass='ab-unknown-partner-block'>
</app-cta-container>
